var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindstorm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.878 2.002c1.051.045 2.304.503 3.758 1.375 1.602.96 2.632 2.602 3.09 4.925a6.014 6.014 0 0 1 1.1 5.141 3.51 3.51 0 0 0 .894-.71c.578-.63 1.066-1.632 1.464-3.005A1.01 1.01 0 0 1 21.153 9a.844.844 0 0 1 .843.881c-.046 1.049-.506 2.297-1.378 3.746-.96 1.594-2.596 2.623-4.905 3.087a6.013 6.013 0 0 1-5.173 1.107c.18.333.421.636.72.91.632.576 1.636 1.063 3.013 1.46.43.124.727.518.727.966a.842.842 0 0 1-.842.842h-.036c-1.051-.046-2.304-.504-3.758-1.376-1.602-.96-2.632-2.603-3.09-4.926a6.012 6.012 0 0 1-1.09-5.182 3.48 3.48 0 0 0-.922.732c-.576.635-1.062 1.644-1.458 3.028a1 1 0 0 1-.962.725.84.84 0 0 1-.84-.84l.001-.034c.043-1.056.5-2.316 1.372-3.778.961-1.613 2.611-2.644 4.949-3.091a6.013 6.013 0 0 1 5.137-1.078 3.501 3.501 0 0 0-.721-.91c-.632-.576-1.636-1.063-3.013-1.46A1.005 1.005 0 0 1 9 2.843c0-.465.377-.842.842-.842h.036zM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindstorm);
export default __webpack_public_path__ + "static/media/windstorm.e15f1a00c92842250ed049259de97b98.svg";
export { ForwardRef as ReactComponent };